import React from "react"
import { Link } from "gatsby"

import "./_logo.scss"

const Logo = () => {
  return (
    <div className="logo">
      <Link className="logo__link" to="/">
        <img src={require("../../assets/images/katika-logo.png")} />
      </Link>
    </div>
  )
}

export default Logo
